// extracted by mini-css-extract-plugin
export var deleteModal = "_s1-0";